module.exports = __webpack_public_path__ + "img/Order Card.45983e45.png";